import { useCallback, useEffect } from 'react';
import { APIv1Endpoint, BASE_URL } from './endpoints';
import { useDispatch, useSelector } from 'react-redux';
import { loadStandingTable, setVersion } from './actions/tableActions';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

export const IFrameMessage = () => {
    const dispatch = useDispatch();
    const params = useParams<{ endpoint: string }>();
    const endpoint = params.endpoint;
    const history = useHistory();
    const affiliate = useSelector((state: any) => state.order.affiliate_code);
    const table_data = useSelector((state: any) => state.table)

    useEffect(() => {
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    });

    const handleBeforeUnload = () => {
        window.top?.postMessage('disconnected', BASE_URL);
    };

    const closeTable = useCallback(async (data: any) => {
        try {
            await axios.post(`${APIv1Endpoint}table/closeTable`, {
                table_id: data.table_id,
                table_session_id: data.table_session_id,
                restaurant_id: data.restaurant_id,
                source: 'ui_cancelOrder',
            });
        } catch (error) {
            setTimeout(() => {
                toast.error('Failed to close table. If the issue presists, please contact the development team.');
                console.error(error);
            }, 1000);
        } finally {
            dispatch(loadStandingTable(endpoint, history, affiliate, false));
            dispatch(setVersion(2));
            setTimeout(() => {
                window.top?.postMessage('resetFinished', BASE_URL);
            }, 500);
        }
    }, [setVersion, loadStandingTable, endpoint, history, affiliate, dispatch]);

    const handleMessage = useCallback(async (event: MessageEvent) => {
        console.log("guest_orders", table_data.guest_orders);
        if (event.data === 'startReset') {
            if (table_data.guest_orders.table_id) {
                closeTable(table_data.guest_orders);
                return
            }
            setTimeout(() => {
                window.top?.postMessage('resetFinished', BASE_URL);
            }, 500);
        }
    }, [closeTable, table_data])

    useEffect(() => {
        window.top?.postMessage('connected', BASE_URL);
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [handleMessage, table_data]);

    return null;
};
